import {MediaProps, MediaType, OfferingType} from "./media.types";

/**
 * Media Entity
 *
 * Represents a media item (image, video, document) in the domain.
 * Contains business logic for media type checks.
 */
export class Media {
  private readonly props: MediaProps;

  private constructor(props: MediaProps) {
    this.props = props;
  }

  /**
   * Factory method to create a Media entity with validation
   */
  static create(props: MediaProps): Media {
    if (props.id === undefined || props.id === null) {
      throw new Error("Media id is required");
    }
    if (!props.url) {
      throw new Error("Media url is required");
    }
    if (!props.type) {
      throw new Error("Media type is required");
    }

    return new Media(props);
  }

  // Getters

  get id(): string | number {
    return this.props.id;
  }

  get url(): string {
    return this.props.url;
  }

  get type(): MediaType {
    return this.props.type;
  }

  get fileName(): string | undefined {
    return this.props.fileName;
  }

  get fileSize(): number | undefined {
    return this.props.fileSize;
  }

  get offeringId(): number | undefined {
    return this.props.offeringId;
  }

  get offeringType(): OfferingType | undefined {
    return this.props.offeringType;
  }

  get userId(): number | undefined {
    return this.props.userId;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  // Business Logic Methods

  /**
   * Check if this media is an image
   */
  isImage(): boolean {
    return this.props.type === "image";
  }

  /**
   * Check if this media is a video
   */
  isVideo(): boolean {
    return this.props.type === "video";
  }

  /**
   * Check if this media is a document
   */
  isDocument(): boolean {
    return this.props.type === "document";
  }

  /**
   * Convert entity back to plain props object
   */
  toProps(): MediaProps {
    return {...this.props};
  }
}
